import { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hook";
import {
    formatMonth,
    formatYear,
    getPreviousMonth
} from "../../lib/utilis";
import { colors } from "../../ui/colors";
import { CurrencyEuroIcon } from "../../ui/icons/currencyEuroIcon";
import { BillowButton } from "../../ui/molecules/billowButton";
import { InputComponent } from "../../ui/molecules/input/index";
import { ModalComponent } from "../../ui/organisms/modal/index";
import {
    createInvoiceAmount,
    setCreateInvoiceAmountCents,
    setOpenNewInvoiceAmountModal,
} from "./slice";

export function NewInvoiceAmountModal() {
  const invoiceAmountState = useAppSelector((state) => state.invoiceAmount);
  const dispatch = useAppDispatch();
  const [isEditingAmount, setIsEditingAmount] = useState(false);
  const [tempAmount, setTempAmount] = useState("");

  const previousMonthDate = getPreviousMonth();

  useEffect(() => {
    if (invoiceAmountState.openNewInvoiceAmountModal) {
      dispatch(setCreateInvoiceAmountCents(0));
    }
  }, [invoiceAmountState.openNewInvoiceAmountModal]);

  return (
    <ModalComponent
      width="medium"
      open={invoiceAmountState.openNewInvoiceAmountModal}
      handleClose={() => {
        dispatch(setOpenNewInvoiceAmountModal(false));
      }}
    >
      <div
        style={{
          padding: "20px",
          backgroundColor: colors.white,
          boxShadow: "0px 12px 24px 0px rgba(22, 42, 100, 0.12)",
          borderRadius: "12px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          width: "100%",
        }}
      >
        <div className="flex items-center justify-between">
          <span className="text-heading-xs font-semibold text-neutral-600">
            {"Crea costo mensile"}
          </span>
        </div>
        <div
          className="flex flex-col items-start"
          style={{ gap: "16px", width: "100%" }}
        >
          <div className=" flex flex-col items-center gap-4 w-full">
            <InputComponent
              label="Mese"
              type={"text"}
              value={formatMonth(previousMonthDate, true)}
              onChangeText={(value) => {
                // TODO: gestire il cambio del mese
              }}
              required
              disabled
            />
            <InputComponent
              label="Anno"
              type={"text"}
              value={formatYear(previousMonthDate)}
              onChangeText={(value) => {
                // TODO: gestire il cambio dell'anno
              }}
              required
              disabled
            />
            <NumericFormat
              key={"costo-mensile-cloud-price"}
              customInput={InputComponent}
              label="Costo mensile Cloud"
              defaultValue={
                (invoiceAmountState.createInvoiceAmountRequest.amount_cents ||
                  0) / 100
              }
              onValueChange={(values) => {
                const pureNumber = values.floatValue || 0;
                const number = Math.round(pureNumber * 100);
                dispatch(setCreateInvoiceAmountCents(number));
              }}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale={true}
              allowNegative={false}
              required
              startIcon={
                <CurrencyEuroIcon size={"20"} color={colors.neutral[400]} />
              }
            />
          </div>
        </div>
        <div className={"flex gap-3 items-center w-full justify-center"}>
          <BillowButton
            label={"Annulla"}
            onClick={() => {
              dispatch(setCreateInvoiceAmountCents(0));
              dispatch(setOpenNewInvoiceAmountModal(false));
            }}
            variant={"outline"}
            iconPosition="off"
            fullWidth
          />
          <BillowButton
            label={"Crea"}
            onClick={() => {
              dispatch(
                createInvoiceAmount({
                  month: Number(formatMonth(previousMonthDate, false)),
                  year: Number(formatYear(previousMonthDate)),
                  amount_cents:
                    invoiceAmountState.createInvoiceAmountRequest.amount_cents,
                }),
              );
              dispatch(setOpenNewInvoiceAmountModal(false));
            }}
            variant={"solid"}
            iconPosition="off"
            fullWidth
          />
        </div>
      </div>
    </ModalComponent>
  );
}
